import DOMPurify from 'dompurify';
class SyntaxColoringService {
    constructor(encoder) {
        this.encodeHtml = (value) => {
            const html = this._encoder(value);
            return this._sanitizeHtml(html);
        };
        this._sanitizeHtml = (html) => DOMPurify.sanitize(html);
        this._encoder = encoder;
    }
}
export default SyntaxColoringService;
//# sourceMappingURL=SyntaxColoringService.js.map